module.exports = require("./../../../_gen/openfl/display3D/textures/Texture");